import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const TIPOS = [
  { value: 'proveedor',          label: 'Proveedor' },
  { value: 'contratista',        label: 'Contratista' },
  { value: 'proveedor_material', label: 'Proveedor de materiales' },
  { value: 'otro',               label: 'Otro' },
];

const VACIO = {
  nombre: '', tipo: 'proveedor', direccion: '', comuna: '',
  ciudad: '', telefono: '', email: '', notas: '',
};

function Campo({ label, value, onChange, placeholder = '', type = 'text', area = false }) {
  const style = {
    width: '100%', padding: '9px 12px', border: '1.5px solid #2E4A40',
    borderRadius: 8, fontSize: 13, fontFamily: 'inherit',
    background: '#0D1311', color: '#F4F7F5', boxSizing: 'border-box', outline: 'none',
    resize: area ? 'vertical' : undefined, minHeight: area ? 70 : undefined,
  };
  return (
    <div style={{ marginBottom: 10 }}>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 700,
        color: '#8A9994', marginBottom: 4, textTransform: 'uppercase' }}>
        {label}
      </label>
      {area
        ? <textarea value={value} onChange={e => onChange(e.target.value)}
            placeholder={placeholder} style={style} />
        : <input type={type} value={value} onChange={e => onChange(e.target.value)}
            placeholder={placeholder} style={style} />
      }
    </div>
  );
}

export default function Directorio() {
  const navigate = useNavigate();
  const [tab, setTab]               = useState('proveedores');
  const [proveedores, setProveedores] = useState([]);
  const [comunidades, setComunidades] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [form, setForm]             = useState({ ...VACIO });
  const [editId, setEditId]         = useState(null);
  const [guardando, setGuardando]   = useState(false);
  const [modal, setModal]           = useState(false);
  const [busqueda, setBusqueda]     = useState('');

  const cargar = async () => {
    setLoading(true);
    try {
      const [prov, com] = await Promise.all([
        api.get('/directorio/proveedores'),
        api.get('/directorio/comunidades'),
      ]);
      setProveedores(prov.data);
      setComunidades(com.data);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => {
    setForm({ ...VACIO });
    setEditId(null);
    setModal(true);
  };

  const abrirEditar = (p) => {
    setForm({
      nombre:    p.nombre   || '',
      tipo:      p.tipo     || 'proveedor',
      direccion: p.direccion || '',
      comuna:    p.comuna   || '',
      ciudad:    p.ciudad   || '',
      telefono:  p.telefono || '',
      email:     p.email    || '',
      notas:     p.notas    || '',
    });
    setEditId(p.id);
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre.trim()) { alert('El nombre es obligatorio'); return; }
    setGuardando(true);
    try {
      if (editId) {
        await api.put(`/directorio/proveedores/${editId}`, form);
      } else {
        await api.post('/directorio/proveedores', form);
      }
      setModal(false);
      cargar();
    } catch (e) {
      alert(e.response?.data?.error || 'Error al guardar');
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id, nombre) => {
    if (!window.confirm(`¿Eliminar "${nombre}"?`)) return;
    try {
      await api.delete(`/directorio/proveedores/${id}`);
      cargar();
    } catch { alert('Error al eliminar'); }
  };

  const setF = (key) => (val) => setForm(p => ({ ...p, [key]: val }));

  const provFiltrados = proveedores.filter(p =>
    p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
    (p.tipo || '').toLowerCase().includes(busqueda.toLowerCase()) ||
    (p.comuna || '').toLowerCase().includes(busqueda.toLowerCase())
  );

  const comFiltradas = comunidades.filter(c =>
    c.comunidad.toLowerCase().includes(busqueda.toLowerCase()) ||
    (c.direccion || '').toLowerCase().includes(busqueda.toLowerCase()) ||
    (c.comuna || '').toLowerCase().includes(busqueda.toLowerCase())
  );

  const tipoLabel = (t) => TIPOS.find(x => x.value === t)?.label || t;

  return (
    <div className="app-container">
      <div className="app-header" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button className="back-btn" onClick={() => navigate('/')}>←</button>
          <h1 style={{ flex: 1, margin: 0 }}>📋 Directorio</h1>
          {tab === 'proveedores' && (
            <button onClick={abrirNuevo} style={{
              background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white',
              borderRadius: 8, padding: '6px 14px', fontSize: 13, fontWeight: 700,
              cursor: 'pointer',
            }}>+ Agregar</button>
          )}
        </div>
        {/* Tabs */}
        <div style={{ display: 'flex', marginTop: 10, borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
          {[
            { id: 'proveedores', label: '🏭 Proveedores' },
            { id: 'comunidades', label: '🏢 Clientes / Comunidades' },
          ].map(t => (
            <button key={t.id} onClick={() => { setTab(t.id); setBusqueda(''); }}
              style={{
                background: 'none', border: 'none', color: 'white', cursor: 'pointer',
                padding: '8px 14px', fontSize: 13, fontWeight: tab === t.id ? 700 : 400,
                borderBottom: tab === t.id ? '3px solid white' : '3px solid transparent',
              }}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="page-content">
        {/* Búsqueda */}
        <input
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          placeholder="🔍 Buscar..."
          style={{
            width: '100%', padding: '10px 12px', border: '1.5px solid #2E4A40',
            borderRadius: 10, fontSize: 14, boxSizing: 'border-box',
            fontFamily: 'inherit', marginBottom: 12, outline: 'none',
            background: '#0D1311', color: '#F4F7F5',
          }}
        />

        {loading ? (
          <div className="spinner" />
        ) : tab === 'proveedores' ? (
          <>
            {provFiltrados.length === 0 ? (
              <p style={{ color: '#6B7C74', textAlign: 'center', marginTop: 32 }}>
                {busqueda ? 'Sin resultados' : 'No hay proveedores. Toca "+ Agregar" para comenzar.'}
              </p>
            ) : provFiltrados.map(p => (
              <div key={p.id} className="card" style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between',
                  alignItems: 'flex-start', gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#F4F7F5',
                      marginBottom: 2 }}>
                      {p.nombre}
                    </div>
                    <span style={{ fontSize: 11, fontWeight: 700, background: '#12382D',
                      color: '#4CAF50', borderRadius: 20, padding: '2px 8px' }}>
                      {tipoLabel(p.tipo)}
                    </span>
                    {(p.direccion || p.comuna) && (
                      <div style={{ fontSize: 12, color: '#8A9994', marginTop: 6 }}>
                        📍 {[p.direccion, p.comuna, p.ciudad].filter(Boolean).join(', ')}
                      </div>
                    )}
                    {p.telefono && (
                      <a href={`tel:${p.telefono}`}
                        style={{ fontSize: 12, color: '#4CAF50', fontWeight: 600,
                          display: 'block', marginTop: 4, textDecoration: 'none' }}>
                        📞 {p.telefono}
                      </a>
                    )}
                    {p.email && (
                      <a href={`mailto:${p.email}`}
                        style={{ fontSize: 12, color: '#38BDF8', display: 'block',
                          marginTop: 2, textDecoration: 'none' }}>
                        ✉ {p.email}
                      </a>
                    )}
                    {p.notas && (
                      <div style={{ fontSize: 11, color: '#6B7C74', marginTop: 6,
                        fontStyle: 'italic', borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 6 }}>
                        {p.notas}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <button onClick={() => abrirEditar(p)} style={{
                      background: '#12382D', border: '1px solid rgba(76,175,80,0.2)', color: '#4CAF50',
                      borderRadius: 8, padding: '5px 10px', fontSize: 12,
                      fontWeight: 600, cursor: 'pointer',
                    }}>Editar</button>
                    <button onClick={() => eliminar(p.id, p.nombre)} style={{
                      background: '#2D0F0F', border: '1px solid rgba(239,68,68,0.2)', color: '#EF4444',
                      borderRadius: 8, padding: '5px 10px', fontSize: 12,
                      fontWeight: 600, cursor: 'pointer',
                    }}>Eliminar</button>
                    {p.direccion && (
                      <a href={`https://maps.google.com/?q=${encodeURIComponent(
                        [p.direccion, p.comuna, p.ciudad].filter(Boolean).join(', ')
                      )}`} target="_blank" rel="noopener noreferrer" style={{
                        background: '#0D1E2E', border: '1px solid rgba(56,189,248,0.2)', color: '#38BDF8',
                        borderRadius: 8, padding: '5px 10px', fontSize: 12,
                        fontWeight: 600, textDecoration: 'none', textAlign: 'center',
                      }}>🗺 Maps</a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <>
            {comFiltradas.length === 0 ? (
              <p style={{ color: '#6B7C74', textAlign: 'center', marginTop: 32 }}>
                Sin resultados
              </p>
            ) : comFiltradas.map((c, i) => (
              <div key={i} className="card" style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between',
                  alignItems: 'flex-start', gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, color: '#F4F7F5',
                      marginBottom: 4 }}>
                      {c.comunidad}
                    </div>
                    <div style={{ fontSize: 12, color: '#8A9994' }}>
                      📍 {[c.direccion, c.comuna, c.ciudad].filter(Boolean).join(', ')}
                    </div>
                  </div>
                  {(c.link_maps || c.lat) && (
                    <a href={c.link_maps ||
                      `https://maps.google.com/?q=${c.lat},${c.lng}`}
                      target="_blank" rel="noopener noreferrer" style={{
                        background: '#0D1E2E', border: '1px solid rgba(56,189,248,0.2)', color: '#38BDF8',
                        borderRadius: 8, padding: '6px 12px', fontSize: 12,
                        fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap',
                        flexShrink: 0,
                      }}>🗺 Abrir Maps</a>
                  )}
                  {!c.link_maps && !c.lat && c.direccion && (
                    <a href={`https://maps.google.com/?q=${encodeURIComponent(
                      [c.direccion, c.comuna].filter(Boolean).join(', ')
                    )}`} target="_blank" rel="noopener noreferrer" style={{
                      background: '#0D1E2E', border: '1px solid rgba(56,189,248,0.2)', color: '#38BDF8',
                      borderRadius: 8, padding: '6px 12px', fontSize: 12,
                      fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap',
                      flexShrink: 0,
                    }}>🗺 Buscar</a>
                  )}
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      {/* Modal agregar/editar proveedor */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
          zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
          <div style={{ background: '#111714', borderRadius: '20px 20px 0 0',
            padding: '24px 20px 40px', width: '100%', maxWidth: 480,
            maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', marginBottom: 20,
              borderBottom: '1px solid rgba(255,255,255,0.08)', paddingBottom: 16 }}>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#F4F7F5' }}>
                {editId ? 'Editar proveedor' : 'Nuevo proveedor'}
              </h3>
              <button onClick={() => setModal(false)} style={{
                background: 'none', border: 'none', fontSize: 22, cursor: 'pointer',
                color: '#8A9994',
              }}>✕</button>
            </div>

            <Campo label="Nombre *" value={form.nombre} onChange={setF('nombre')}
              placeholder="Ej: Ferretería Central" />

            <div style={{ marginBottom: 10 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700,
                color: '#8A9994', marginBottom: 4, textTransform: 'uppercase' }}>
                Tipo
              </label>
              <select value={form.tipo} onChange={e => setF('tipo')(e.target.value)}
                style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #2E4A40',
                  borderRadius: 8, fontSize: 13, fontFamily: 'inherit',
                  background: '#0D1311', color: '#F4F7F5', boxSizing: 'border-box' }}>
                {TIPOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>

            <Campo label="Dirección" value={form.direccion} onChange={setF('direccion')}
              placeholder="Av. Ejemplo 1234" />
            <Campo label="Comuna" value={form.comuna} onChange={setF('comuna')}
              placeholder="Las Condes" />
            <Campo label="Ciudad" value={form.ciudad} onChange={setF('ciudad')}
              placeholder="Santiago" />
            <Campo label="Teléfono" value={form.telefono} onChange={setF('telefono')}
              placeholder="+56 9 1234 5678" type="tel" />
            <Campo label="Email" value={form.email} onChange={setF('email')}
              placeholder="contacto@empresa.cl" type="email" />
            <Campo label="Notas" value={form.notas} onChange={setF('notas')}
              placeholder="Horarios, contacto, observaciones..." area />

            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button onClick={() => setModal(false)} style={{
                flex: 1, padding: 13, borderRadius: 10,
                border: '1px solid rgba(255,255,255,0.12)',
                background: '#161C19', fontSize: 14, fontWeight: 600, color: '#C9D3CE',
                cursor: 'pointer',
              }}>Cancelar</button>
              <button onClick={guardar} disabled={guardando} style={{
                flex: 2, padding: 13, borderRadius: 10, border: 'none',
                background: guardando ? '#0a4433' : '#0f6e56', color: 'white',
                fontSize: 14, fontWeight: 700, cursor: 'pointer',
              }}>
                {guardando ? 'Guardando...' : editId ? 'Guardar cambios' : 'Agregar proveedor'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
